/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageModeDestPanelFrameComponent } from './manage-mode-dest-panel-frame.component';
import { SelectSystemModule } from '../select-system';
import { SelectCategoryModule } from '../select-category';
import { CategoryScopeModule } from '../category-scope';
import { DxContextMenuModule } from 'devextreme-angular';
import { RootPathSelectorModule } from '../root-path-selector';

@NgModule({
  declarations: [ManageModeDestPanelFrameComponent],
  imports: [
    CommonModule,
    SelectSystemModule,
    SelectCategoryModule,
    CategoryScopeModule,
    DxContextMenuModule,
    RootPathSelectorModule
  ],
  exports: [ManageModeDestPanelFrameComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageModeDestPanelFrameModule {}
